
import { Component, Vue } from "vue-property-decorator";
import { GaodeService, OrganizationService, PackageService, OrderService, FamilyService } from "src/services";

@Component
export default class GoodsDetail extends Vue
{
    /**
     * 商品数量
     * @private
     * @returns number
     */
    private goodsNum: number = 1;

    /**
     * 商品详情id
     * @private
     * @returns string
     */
     private get id(): string
    {
        return this.$route.query && (this.$route.query.id as string) || "";
    }

    /**
     * 跳转订单明细
     * @private
     * @returns void
     */
    private onActionOrderDetail(): void
    {
        this.$router.push({name: "rights-order-detail", query:{id: this.id}});
    }

    /**
     * 跳转首页
     * @private
     * @returns void
     */
    private onHome(): void
    {
        this.$router.push({name: "home"});
    }

    /**
     * 获取数据
     * @private
     * @returns void
     */
     private get appid(): string
    {
        return localStorage.getItem("appid") || "";
    }

    /**
     * 跳转健康首页
     * @private
     * @returns void
     */
    private onHealthHome(): void
    {
        this.$router.push({name: "health-product-home"});
    }



}
